module.exports = __webpack_public_path__ + "static/media/SettingMt.33e436de.svg";